import React from 'react'
import RenderDelay from './../render_delay/RenderDelay'

const SuspenseLoader = () => {
    return (
        <div style={{ height: 800 }}>
            {/* Lock in the height so that the footer doesn't flash when loading the pages  */}
            <RenderDelay>
                <div className="loader_dots" />
            </RenderDelay>
        </div>
    )
}

export default SuspenseLoader
